import React from "react";
import "../../../css/Common/Components/DesignSystem/HeroAnimation.css";

/**
 * HeroAnimation component renders an image with an optional card overlay.
 *
 * @param {Object} props - The component props.
 * @param {string} props.imgSrc - The source URL for the hero image.
 * @param {React.ReactNode} props.children - The content to display inside the card overlay.
 * @param {boolean} [props.isAdviser=false] - If true, applies the "Adviser" style to the card.
 * @param {string} [props.altText=""] - The alt text for the hero image.
 * @returns {JSX.Element} The rendered HeroAnimation component.
 */
const HeroAnimation = ({
  imgSrc,
  children,
  isAdviser = false,
  altText = "",
}) => {
  const cardClass = `Hero-Card ${isAdviser ? "Adviser" : ""}`.trim();

  return (
    <div className="Hero-Animation-Container">
      <img loading="eager" fetchPriority="high" src={imgSrc} alt={altText} />
      <div className={cardClass}>{children}</div>
    </div>
  );
};

export default HeroAnimation;
